import { render, staticRenderFns } from "./dialog-profile.vue?vue&type=template&id=6c968c13&"
import script from "./dialog-profile.vue?vue&type=script&lang=js&"
export * from "./dialog-profile.vue?vue&type=script&lang=js&"
import style0 from "./dialog-profile.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports